import React from "react";

const NewsLetter = () => {
  return (
    <div
      className="container-fluid py-5"
      style={{ backgroundColor: "#F9FAFB" }}
    >
      <div className="container text-center">
        <h4 className="fw-bold" style={{ color: "#2C2F76" }}>
          Subscribe to Our Newsletter
        </h4>
        <p className="text-muted mb-4">
          Stay updated with our latest insights, articles, and industry news.
        </p>

        <div className="d-flex justify-content-center align-items-center gap-2 mb-3">
          <input
            type="email"
            placeholder="Your email address"
            className="form-control"
            style={{
              maxWidth: "400px",
              height: "45px",
              border: "1px solid #E5E7EB",
              borderRadius: "6px",
            }}
          />
          <button
            className="btn fw-medium"
            style={{
              backgroundColor: "#2C2F76",
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "6px",
            }}
          >
            Subscribe
          </button>
        </div>

        <p className="text-muted" style={{ fontSize: "0.85rem" }}>
          We respect your privacy. You can unsubscribe at any time.
        </p>
      </div>
    </div>
  );
};

export default NewsLetter;

